import React from 'react'
import StatusApplication from './StatusApplication'
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const ExpiredRenewApplications = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editRenewExpiredApplications.role,
    permissionsConfig.editRenewExpiredApplications.action,
    permissionsConfig.editRenewExpiredApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteRenewExpiredApplications.role,
    permissionsConfig.deleteRenewExpiredApplications.action,
    permissionsConfig.deleteRenewExpiredApplications.type
  );

  return (
    <StatusApplication appStatus="6" title="Expired" subTitle="Expired" application_type="1" pageFrom="renew/expired" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
}

export default ExpiredRenewApplications